import { render, staticRenderFns } from "./CreatePlanPrevention.vue?vue&type=template&id=607c73de&scoped=true&"
import script from "./CreatePlanPrevention.vue?vue&type=script&lang=ts&"
export * from "./CreatePlanPrevention.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePlanPrevention.vue?vue&type=style&index=0&id=607c73de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c73de",
  null
  
)

export default component.exports